import React from 'react';
import PropTypes from 'prop-types';
import { useSetAtom } from 'jotai';
import useSignalR from '../../Services/signalR';
import {
  notifyMailReceivedAtom,
  notifyMailSentAtom,
} from '../../Atoms/HubAtoms';

export default function ChatHubProvider({ channel }) {
  const setNotifyMailSent = useSetAtom(notifyMailSentAtom);
  const setNotifyMainReceived = useSetAtom(notifyMailReceivedAtom);

   
  useSignalR(`${window.databeasy?.API_URL}hubs/mailhub`, channel, [
    {
      eventName: 'NotifyMailSent',
      callback: (message) => {
        setNotifyMailSent(message);
      },
    },
    {
      eventName: 'NotifyMailReceived',
      callback: (message) => {
        setNotifyMainReceived(message);
      },
    },
  ]);

  return <div />;
}

ChatHubProvider.propTypes = {
  channel: PropTypes.string.isRequired,
};
